<div class="wrapper"  mat-ripple [matTooltip]="tooltip" [matTooltipDisabled]="!tooltip">
  <fa-icon [icon]="icon" size="2x"></fa-icon>
</div>
